import { Injectable } from '@angular/core';
import { CANVAS_OPTIONS } from 'src/app/data/canvas-options';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CanvasOptionsService {

  private readonly _canvasOptions= new BehaviorSubject<any>(CANVAS_OPTIONS);
  private _currentCanvasOptions: any;
  canvasOptions$ = this._canvasOptions.asObservable();
  
  private previousBckgValue=null;

  constructor() {
    this._currentCanvasOptions=CANVAS_OPTIONS;
   }

  toggleGrid(){
    this._currentCanvasOptions.grid=!this._currentCanvasOptions.grid;
    this._canvasOptions.next(this._currentCanvasOptions);
  }
  
  toggleAlign(){
    this._currentCanvasOptions.align=!this._currentCanvasOptions.align;
    this._canvasOptions.next(this._currentCanvasOptions);
  }

  setAlign(mode){
    this._currentCanvasOptions.align=mode;
    this._canvasOptions.next(this._currentCanvasOptions);
  }

  toggleBackground(){
    if(this._currentCanvasOptions.background==null || this._currentCanvasOptions.background==0){
      this._currentCanvasOptions.background=this.previousBckgValue;
    }else{
      this.previousBckgValue=this._currentCanvasOptions.background
      this._currentCanvasOptions.background=0
    }
    
    this._canvasOptions.next(this._currentCanvasOptions);
  }

  setBackgroundImage(base64){
    this._currentCanvasOptions.background = 2;
    this._currentCanvasOptions.image = base64;
    this._canvasOptions.next(this._currentCanvasOptions);
  }

  setMapData(map:any){
    
    this._currentCanvasOptions.background = 1;
    this._currentCanvasOptions.map.lat = map.lat;
    this._currentCanvasOptions.map.lng = map.lng
    this._currentCanvasOptions.map.zoom = map.zoom;
    this._currentCanvasOptions.map.image = map.image;

    this._currentCanvasOptions.map.metersPerPx = 156543.03392 * Math.cos(map.lat * Math.PI / 180) / Math.pow(2, map.zoom)
    
    this._canvasOptions.next(this._currentCanvasOptions);
  }

  setActiveZone(type:string,id:number){
    
    this._currentCanvasOptions.activeZone={name:type,id:id}
    this._canvasOptions.next(this._currentCanvasOptions);
  }

  getActiveZone(){
    return this._currentCanvasOptions.activeZone;
  }

  clearAction(){
    this._currentCanvasOptions.activeZone={name:null,id:null}
    this._canvasOptions.next(this._currentCanvasOptions);
  }

}
